module.exports = __webpack_public_path__ + "static/media/bgGray.f427ef1d.webp";